module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"field_gatsby-starter","short_name":"starter","start_url":"/","background_color":"#f1c71d","theme_color":"#f1c71d","display":"minimal-ui","icon":"src/images/topaz-favicon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"23e6009bae81dd59483bcba17a054638"},
    },{
      plugin: require('../node_modules/gatsby-plugin-layout/gatsby-browser.js'),
      options: {"plugins":[],"component":"/opt/build/repo/src/components/layout/index.js"},
    },{
      plugin: require('../node_modules/gatsby-plugin-prismic-previews/gatsby-browser.js'),
      options: {"plugins":[],"repositoryName":"topazwebsite","accessToken":"MC5ha0tOLVJNQUFDNEFvTlN2.77-977-977-977-9K--_vQ5d77-9dO-_vV_vv71gdO-_vVpV77-9du-_ve-_vX3vv73vv71d77-977-977-977-977-977-9"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
